import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGrade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M8.25 7.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm6.78 4.289a5.25 5.25 0 1 0-6.058 0A8.754 8.754 0 0 0 3.249 20v1a.75.75 0 0 0 1.5 0v-1a7.25 7.25 0 1 1 14.5 0v1a.75.75 0 0 0 1.5 0v-1a8.754 8.754 0 0 0-5.72-8.211Z"
    />
    <path
      fill="#F7A600"
      d="M12.853 13.244a1.2 1.2 0 1 0-1.706 0l-1.478 4.927a.4.4 0 0 0 .1.398l1.807 1.807a.6.6 0 0 0 .848 0l1.807-1.807a.4.4 0 0 0 .1-.398l-1.478-4.927Z"
    />
  </svg>
);
export default SvgTwoColorGrade;
